let filterTypes = [];

export function filterAlumni() {

  $('.filters select').each(function(){
    var thisType = $(this).attr('name');
    filterTypes[thisType] = [];
    console.log(filterTypes);
  })

  $('.filters select').on('change', function(e){
    var selectType    = e.currentTarget.name,
        selectOption  = this.value;

    $('.filters select:not([name=' + selectType +'])').prop('selectedIndex', 0);

    filterTypes[selectType] = selectOption;
    // console.log(filterTypes);

    // var cards = $('.card-person-alumni[data-' + selectType + '="'+ selectOption +'"]');
    // console.log(cards);
    if(selectOption) {
      $('.card-person-alumni').hide();
      $('.card-person-alumni[data-' + selectType + '="'+ selectOption +'"]').show();
    } else {
      $('.card-person-alumni').show();
    }
  })

}



// WEBPACK FOOTER //
// ./scripts/functions/filter-alumni.js